var e = function e(_e, r) {
  return {
    enumerable: !(1 & _e),
    configurable: !(2 & _e),
    writable: !(4 & _e),
    value: r
  };
};
export { e as c };